var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusIconProcess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24.001 24",
    width: 24.001,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Process",
    transform: "translate(-16531.999 4804)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 24,
    id: "Back",
    transform: "translate(16532 -4804)",
    width: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "transaction_5336787",
    transform: "translate(16530.285 -4805.714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.146,21.193l4.286,2.448a.867.867,0,0,0,.85,0l4.286-2.448A.856.856,0,0,0,12,20.448v-4.9a.87.87,0,0,0-.432-.744L7.282,12.357a.855.855,0,0,0-.85,0L2.146,14.806a.872.872,0,0,0-.432.745v4.9a.856.856,0,0,0,.432.744Zm8.139-1.242L7.714,21.42V18.5l2.571-1.469ZM6.857,14.089l2.558,1.461L6.857,17.013,4.3,15.551ZM3.428,17.027,6,18.5V21.42L3.428,19.951Z",
    "data-name": "Path 8333",
    fill: "#ffff",
    id: "Path_8333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.282,4.521,21,2.073a.855.855,0,0,0-.85,0L15.86,4.521a.87.87,0,0,0-.432.744v4.9a.856.856,0,0,0,.432.744l4.286,2.449a.865.865,0,0,0,.85,0l4.286-2.449a.856.856,0,0,0,.432-.744v-4.9A.862.862,0,0,0,25.282,4.521Zm-5.568,6.614L17.142,9.666V6.742l2.571,1.469Zm.857-4.408L18.012,5.265,20.571,3.8l2.558,1.461ZM24,9.666l-2.571,1.469V8.211L24,6.742Z",
    "data-name": "Path 8334",
    fill: "#ffff",
    id: "Path_8334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,23.142a.857.857,0,1,1,.857.857A.857.857,0,0,1,12,23.142Z",
    "data-name": "Path 8335",
    fill: "#ffff",
    id: "Path_8335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.571,23.142a.857.857,0,1,1,.857.857A.857.857,0,0,1,14.571,23.142Z",
    "data-name": "Path 8336",
    fill: "#ffff",
    id: "Path_8336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.714,18.857a.857.857,0,1,1,.857.857A.857.857,0,0,1,19.714,18.857Z",
    "data-name": "Path 8337",
    fill: "#ffff",
    id: "Path_8337"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.714,16.285a.857.857,0,1,1,.857.857A.857.857,0,0,1,19.714,16.285Z",
    "data-name": "Path 8338",
    fill: "#ffff",
    id: "Path_8338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.537,5.394l.251-.251H6.857A1.716,1.716,0,0,0,5.143,6.857v3.428a.857.857,0,0,1-1.714,0V6.857A3.432,3.432,0,0,1,6.857,3.428h3.931l-.251-.251a.857.857,0,1,1,1.212-1.212L13.463,3.68a.86.86,0,0,1,0,1.213L11.749,6.607a.857.857,0,0,1-1.212-1.213Z",
    "data-name": "Path 8339",
    fill: "#ffff",
    id: "Path_8339"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.463,21.679l1.778,1.778,2.872-5.025a.857.857,0,1,1,1.488.85l-3.428,6a.857.857,0,0,1-1.35.181l-2.571-2.571a.857.857,0,0,1,1.212-1.212Z",
    "data-name": "Path 8340",
    fill: "#ffff",
    id: "Path_8340"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusIconProcess);
export default __webpack_public_path__ + "static/media/status_icon_process.90c96a8c790803cbaf7cfe8216996a64.svg";
export { ForwardRef as ReactComponent };